import ServiceBase from '../ServiceBase';

export default class CommentsAdminService extends ServiceBase {

    exportProjectComments(projectID) {
        return this.request('post', 'admin/comments/exportProjectComments', { projectID });
    }

    getReportedComments(filters = {}, pageIndex = 0) {
        const params = {
            pageIndex,
            ...filters,
        };
        return this.request('post', 'admin/comments/searchReportedComments', params);
    }

    updateCommentApproval(commentID, moderationActionType, reviewerID) {
        return this.request('post', 'admin/comments/updateCommentApproval', { commentID, moderationActionType, reviewerID });
    }

    searchComments(creatorID, projectID = null, filters = {}, pageSize = null, pageIndex = null) {
        const params = {
            ...filters,
            projectID,
            creatorID,
            pageSize,
            pageIndex,
        };

        return this.request('post', 'admin/comments/searchComments', params);
    }

    getDashboardComments(projectID) {
        return this.request('get', 'admin/comments/getDashboardComments', { projectID });
    }

    updateCommentLanguage({
        commentID,
        creatorID,
        languageID,
        projectID = null,
    }) {
        return this.request('post', 'admin/comments/updateCommentLanguage', {
            commentID,
            creatorID,
            languageID,
            projectID,
        });
    }

    deleteAllUserComments(userID) {
        return this.request('post', 'admin/comments/bulkDeleteComments', { authorUserID: userID });
    }
}